import moment from 'moment';
export default class Utils {
  // list = { name: , id: }
  static createAlphabetList(list) {
    return list.reduce((accumulator, current) => {
      const index = accumulator.findIndex(item => {
        return item.key.toUpperCase() === current.name.split('')[0].toUpperCase()
      })
      if(-1 === index) {
        accumulator.push({ 
          key: current.name.split('')[0].toUpperCase(),
          id: null
        })
        accumulator[accumulator.length-1]['id'] = current.id
      }
      return accumulator
    }, []).sort((userList1, userList2) => {
      return userList1.key < userList2.key ? -1 : 1
    })
  }
  static decodeData(data) {
    return new Buffer(data, 'base64').toString('ascii');
  }
  static decodeHost(host) {
    const data = new Buffer(host, 'base64').toString('ascii');
    return JSON.parse(data);
  }
  static encodeData(data) {
    return new Buffer(data).toString('base64');
  }
  static encodeHost(host) {
    const data = new Buffer(JSON.stringify(host)).toString('base64');
    return data;
  }
  static getAccountType(level) {
    return level === 1 ? "Free" : "Business";
  }
  static getFormatDate(dateStr) {
    return moment(dateStr).format('D/M/YYYY');
  }
  static latinify(str, opts) {
    let baseChars = [];
    for (let i = 97; i < 97 + 26; i++) {
      baseChars.push(String.fromCharCode(i));
    }

    function isUpperCase(c) { return c !== c.toLocaleLowerCase() }

    function toBaseChar(c, opts) {
      opts = opts || {};
      if (!('locale' in opts)) opts.locale = 'en';

      var cOpts = {sensitivity: 'base'};

      //exit early for any non-alphabetical character
      if (c.localeCompare('9', opts.locale, cOpts) <= 0) {
        return opts.nonAlphaChar === undefined ? c : opts.nonAlphaChar;
      }

      for (let i = 0; i < baseChars.length; i++) {
        const baseChar = baseChars[i];

        const comp = c.localeCompare(baseChar, opts.locale, cOpts);
        if (comp == 0) return (isUpperCase(c)) ? baseChar.toUpperCase() : baseChar;
      }

      return opts.noMatchChar === undefined ? c : opts.noMatchChar;
    }

    return str.replace(/[^\w\s\d]/g, function(c) {
      return toBaseChar(c, opts);
    })

  }
  static toggleState(toggleState) {
    return !toggleState;
  }
}
